import styled from 'styled-components'
import { colors } from '@/styles'
import { Label } from '@/components/text'

const Wrapper = styled.div`
  width: 95px;
  height: 95px;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
`

const Ribbon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  transform: rotate(45deg);
  background-color: ${colors.red64};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  top: 24px;
  left: -13px;
  width: 145px;
  color: ${colors.white};
`

interface Props {
  children: React.ReactNode
}

const CornerRibbon: React.FC<Props> = ({ children }) => (
  <Wrapper>
    <Ribbon>
      <Label fontSize="12px" type="large">
        {children}
      </Label>
    </Ribbon>
  </Wrapper>
)

export default CornerRibbon
